<script lang="ts" setup>
import { useForm } from 'vee-validate'
import { GameLobbyEnum } from '~/enums'
import { GAME_LOBBY_TABS } from '~/resources'
import type { DropdownOption } from '~/types/app'
import type { GameLobbyTabs } from '~/types/game'
import { useLobbyGameFilter } from '~/composables/game/use-lobby-game-filter'

const {
  routeProvider,
  routeCategory,
  filterMobileProviders,
  getImage,
  changeCategory,
  changeProvider,
} = useLobbyGameFilter()

const { isVisible: isHeaderVisible } = useHiddenToScroll({ defaultValue: true })

const lobbyGameRefFilter = ref<HTMLDivElement | null>(null)

const categoryOptions = computed<DropdownOption[]>(() => {
  return GAME_LOBBY_TABS.map((item: GameLobbyTabs) => ({
    key: item.key || GameLobbyEnum.All,
    title: item.titleMobile || item.title,
    icon: item.icon,
  }))
})
const { values, setFieldValue } = useForm({
  initialValues: {
    lobbyGameCategory: routeCategory.value || GameLobbyEnum.All,
    lobbyGameProvider: routeProvider.value || GameLobbyEnum.All,
  },
})

watch(
  () => routeCategory.value,
  () => {
    setFieldValue('lobbyGameCategory', routeCategory.value)
  },
)

watch(
  () => values.lobbyGameCategory,
  () => {
    setFieldValue('lobbyGameProvider', GameLobbyEnum.All)
  },
)
</script>
<template>
  <div class="lobby">
    <div class="lobby__banner">
      <h2 class="lobby__banner__title container">Trò Chơi Đa Dạng</h2>
      <p class="lobby__banner__subtitle container">Thưởng khủng mỗi ngày</p>
    </div>
  </div>

  <div
    class="lobby__content container"
    :style="{
      top: isHeaderVisible ? '54px' : 0,
    }"
  >
    <form action="#">
      <div class="lobby__filter">
        <div ref="lobbyGameRefFilter" class="lobby__filter__item">
          <FormDropdown
            :options="categoryOptions"
            :clearable="false"
            name="lobbyGameCategory"
            scroll-behavior="close"
          >
            <template #item="{ item, props: itemProps }">
              <div
                :class="[
                  'item-dropdown',
                  'bank-dropdown-item  w-100',
                  {
                    'bank-dropdown-item--selected':
                      routeCategory === item.raw.key,
                  },
                  { 'bank-dropdown-item--hidden': item.value === '' },
                ]"
                v-bind="itemProps"
                title=""
                @click="changeCategory(item.raw.key as GameLobbyEnum)"
              >
                <img
                  class="logo-category-game"
                  :alt="item.title"
                  :src="
                    getImage(
                      routeCategory === item.raw.key
                        ? `${item.raw.icon}-active-mb`
                        : `${item.raw.icon}-mb`,
                    )
                  "
                />
                <span class="bank-dropdown-item__title line-limit-1">{{
                  item.title
                }}</span>
              </div>
            </template>
            <template #selection="{ item }">
              <div class="bank-dropdown-selection-item">
                <img
                  class="logo-category-game"
                  :alt="item.title"
                  :src="getImage(`${item.raw.icon}-active-mb`)"
                />
                <span
                  class="bank-dropdown-selection-item__title line-limit-1"
                  >{{ item.title }}</span
                >
              </div>
            </template>
          </FormDropdown>
        </div>
        <div class="lobby__filter__item">
          <FormDropdown
            :options="filterMobileProviders"
            :clearable="false"
            name="lobbyGameProvider"
            scroll-behavior="close"
          >
            <template #item="{ item, props: itemProps }">
              <div
                :class="[
                  'item-dropdown',
                  'bank-dropdown-item w-100',
                  {
                    'bank-dropdown-item--selected':
                      (!routeProvider && item.raw.key === GameLobbyEnum.All) ||
                      routeProvider === item.raw?.key,
                  },
                  { 'bank-dropdown-item--hidden': item.value === '' },
                  { 'justify-space-between': item.raw.label },
                ]"
                v-bind="itemProps"
                title=""
                @click="changeProvider(item.raw.key)"
              >
                <span class="bank-dropdown-item__title line-limit-1">{{
                  item.title
                }}</span>
                <img
                  v-if="item.raw.label"
                  class="label-provider-game"
                  :alt="item.title"
                  :src="getImage(`label-${item.raw.label}`, 'webp')"
                />
              </div>
            </template>
            <template #selection="{ item }">
              <div class="bank-dropdown-selection-item">
                <span
                  class="bank-dropdown-selection-item__title line-limit-1"
                  >{{ item.title }}</span
                >
              </div>
            </template>
          </FormDropdown>
        </div>
      </div>
    </form>
  </div>
</template>
<style scoped lang="scss">
@import '/assets/styles/components/mobile/pages/lobby-game/filter.scss';
</style>
